















































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import BaseContainer from '@/components/BaseContainer.vue';
import { default as Trajectory} from '@/components/TrajectoryView.vue';
import CommonPanel from '@/components/CommonPanel.vue';
import { Order, LocationApi ,WayBill} from '@/http';
@Component({
    components: {
        PageDescribe,
        BaseContainer,
        CommonPanel,
        Trajectory,
    },
})
export default class Location extends Vue {
    public title: string = '在线查看在途运单的车辆最新位置信息，支持用户根据运单编号、计划编号、项目编号、车牌号、线路等信息，快速查询车辆最新位置';
    public $refs: {
        Trajectory: HTMLFormElement;
    };

    public showLocationPanel = false;

    public activities = [];
    public id: any = '';
    public data: any = {};
    public isRegister = false;
    public locationSuc = '';
    public carCode:any = '';
    public deliveryAddress:any = '';
    public arrivalAddress:any = '';
    public driverPhone:any = '';
    public async created() {
        this.id = this.$route.query.id;
        this.carCode = this.$route.query.carCode;
        this.deliveryAddress = this.$route.query.deliveryAddress;
        this.arrivalAddress = this.$route.query.arrivalAddress;
        this.driverPhone = this.$route.query.driverPhone;
        this.searchValue = '';
        // this.data = await WayBill.getHistoryLocation({
        //              carrierOrderId: this.id,
        //              skip:0,
        //              count:-1
        //      });
        this.data = await WayBill.getOnlieCars({               
               carrierOrderCode:'',
               orderCode:'',
               projectCode:'',
               carCode:'',
               originProvince:'',
               arrivalProvince:''
        });
        this.$refs.Trajectory.setPoint(this.data);
        // let res = await WayBill.getLbsStatus({
        //     phone: this.driverPhone,
        // });
        // this.isRegister = res.isRegister;
        this.activities = [];
        this.data.data.sort(function (a, b) {
            return b.locationTime < a.locationTime ? -1 : 1;
        });
        this.data.data.forEach((item, index) => {
            if (index == 0) {
                this.activities.push({
                    content: item.address,
                    //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
                    timestamp:item.locationTime,
                    type: '',
                    color: '#0bbd87',
                });
            } else {
                this.activities.push({
                    content: item.address,
                    //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
                    timestamp:item.locationTime,
                    type: '',
                });
            }
        });
    }

    public async init1(id) {
        this.data  = await WayBill.getzndw1({
            //positionType: 1,
            carrierOrderId: id,
        });
        this.init();
    }

    public async init() {
        // this.data = await WayBill.getHistoryLocation({
        //              carrierOrderId: this.id,
        //              skip:0,
        //              count:-1
        //      });
        this.data = await WayBill.getOnlieCars({
               carrierOrderCode:this.searchValue.carrierOrderCode,
               orderCode:this.searchValue.orderCode,
               shipOrderNo:this.searchValue.projectCode,
               carCode:this.searchValue.carCode,
               originProvince:this.searchValue.originProvince,
               arrivalProvince:this.searchValue.arrivalProvince
        });
        this.$refs.Trajectory.setPoint(this.data);
        // let res = await WayBill.getLbsStatus({
        //     phone: this.driverPhone,
        // });
        // this.isRegister = res.isRegister;
        // this.activities = [];
        // this.data.data.sort(function (a, b) {
        //     return b.locationTime < a.locationTime ? -1 : 1;
        // });
        // this.data.data.forEach((item, index) => {
        //     if (index == 0) {
        //         this.activities.push({
        //             content: item.address,
        //             //timestamp: item.bdnpTime == '0001-01-01 00:00:00' || !item.bdnpTime ? item.creationTime : item.bdnpTime,
        //             timestamp:item.locationTime,
        //             type: '',
        //             color: '#0bbd87',
        //         });
        //     } else {
        //         this.activities.push({
        //             content: item.address,
        //             timestamp:item.locationTime,
        //             type: '',
        //         });
        //     }
        // });
    }
    public searchValue:any = ''
    public remap(val,data){
        console.log('remap-->',val,data);
        this.searchValue = val;
        this.GetLocation(2,data);
    }
    public async DredgeLBS() {
        this.locationSuc = '';
        let res = await WayBill.DredgeLBS({
            phone: this.driverPhone,
        });
        this.$message.success(res.messageInfo);
    }

    public locData: any = {};

    public positionType = 1;
    public async GetLocation(positionType,data) {
        //this.showLocationPanel = true;
        this.locationSuc = '';
        this.positionType = positionType;
        // let res = await LocationApi.GetLocation({
        //     positionType: positionType,
        //     phone: this.data.driverPhone,
        //     carCode: this.data.carCode,
        //     carrierOrderId: this.data.carrierOrderId,
        // });
        // let res = await WayBill.getzndw({
        //     positionType: positionType,
        //     carrierOrderId: this.id,
        // });
        // console.log('jfoiewf',res);
        // if (positionType == 1) {
        //     if (res) {
        //         //console.log('lbs-->',res);
        //         this.locData = res;
        //         //this.$refs.LocationPanel.setPoint(this.locData.longitude, this.locData.latitude, this.locData.area, this.locData.creationTime);
        //         this.locationSuc = '定位成功';
        //     } else {
        //         this.$message.warning('定位失败');
        //         this.locationSuc = '定位失败';
        //     }
        // } else {
        //     if (res) {
        //         console.log('北斗',res);
        //         this.locData = res;
        //         //this.$refs.LocationPanel.setPoint(this.locData.lon, this.locData.lat, this.locData.adr, this.locData.utc);
        //         this.locationSuc = '定位成功';
        //     } else {
        //         this.$message.warning('定位失败');
        //         this.locationSuc = '定位失败';
        //     }
        // }
        if (data) {
            this.init1(data);
        } else {
            this.init();
        }

    }

    public mounPageDescribeted() {}

    public searchLoctaion() {
        // let locData = await LocationApi.GetLocation(this.searchValue);
        // this.$refs.LocationPanel.setPoint(locData.longitude, locData.latitude, locData.area, locData.creationTime);
        // let locList = await LocationApi.GetLocationList({ ...this.searchValue, serviceType: 2 });
        // console.log('locList' + JSON.stringify(locList));
        // this.activities = [];
        // locList.data.forEach((item, index) => {
        //     if (index == 0) {
        //         this.activities.push({
        //             content: item.area,
        //             timestamp: item.creationTime,
        //             type: 'danger',
        //             serviceTypeStr: item.serviceTypeStr,
        //         });
        //     } else {
        //         this.activities.push({
        //             content: item.area,
        //             timestamp: item.creationTime,
        //             serviceTypeStr: item.serviceTypeStr,
        //             type: '',
        //         });
        //     }
        // });
    }

    back() {
        this.$router.push('./WayBillManage');
    }
}
